import axios from 'axios';

export const PROFILE = import.meta.env.VITE_ENV;

const service_port = import.meta.env.VITE_SERVICE_PORT;
const host_name = import.meta.env.VITE_HOSTNAME;

const protocol_http = import.meta.env.VITE_PROTOCOL;
const protocol_ws = import.meta.env.VITE_PROTOCOL_WS;

const isLocalHost = host_name === 'localhost';

const domain = process.env.NODE_ENV === 'test' || !isLocalHost ? host_name : 'localhost:' + service_port;

const main_address_http = protocol_http + domain;
const main_address_wss = protocol_ws + domain;

const socket = main_address_wss + '/socket';
const websocket = socket + '/websocket';
const topic = websocket + '/topic';

function getServiceUrlSuffix() {
    switch (PROFILE) {
        case 'production':
            return '';
        case 'staging':
            return '-staging';
        case 'develop':
            return '-develop';
        case 'development':
        default:
            return '-development';
    }
}

const service_url_suffix = getServiceUrlSuffix();

export const GENERAL = {
    PATHS: {
        HOOKS: '/hooks',
        COMPONENTS: '/components',
        PAGES: '/pages',
    },

    ADDRESSES: {
        DOMAIN: domain,
        DOMAIN_MAIN: import.meta.env.VITE_HOSTNAME,

        HTTP: {
            MAIN: main_address_http,
            HEALTH: main_address_http + '/health',
        },

        WSS: {
            WEBSOCKET: websocket,
            DESKS: topic + '/desks',
        },
        ALERT: `wss://alert${service_url_suffix}.birdseyesecurity.com/socket`,
        COOKIEDOMAIN: host_name,
    },

    PREFIXES: {
        STORAGE: 'bfs_aiq_',
    },
    ENV: PROFILE,
};

export const snackBarGeneralConfiguration = {
    maxSnack: 5, //maxNumberOfNotificationsOnScreen
    autoHideDuration: 6000, //number of ms before hiding snackbar general config, can be overwritten for each snackbar when initialising it
};

export const webSocketGeneralConfig = {
    timesToTryReconnect: 4,
    reconnectDelay: 10000,
};

export const locationTransactionsTableRowsPerPage = 21;
export const allLocationsTransactionsTableRowsPerPage = 15;

const resolveTimeoutValue = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const refreshTokenTimeouts = {
    initial: resolveTimeoutValue(import.meta.env.VITE_REFRESH_TOKEN_TIMEOUT_INITIAL_MS, 4000),
    retry: resolveTimeoutValue(import.meta.env.VITE_REFRESH_TOKEN_TIMEOUT_RETRY_MS, 8000),
};

export const axiosSSO = axios.create({
    baseURL: GENERAL.ADDRESSES.HTTP.MAIN,
    withCredentials: true,
});

